import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Mixins, Prop } from "vue-property-decorator";
// S1
import BaseMixer from "@/router/views/BaseMixer";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
let EcTextEditor = /** @class */ (() => {
    let EcTextEditor = class EcTextEditor extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.editorContent = "";
            this.editor = DecoupledEditor;
        }
        // Computed (props aren't available at field-initialization time)
        get editorConfig() {
            return {
                toolbar: {
                    items: this.toolbarItems,
                },
                link: {
                    defaultProtocol: "http://",
                },
                typing: {
                    transformations: {
                        remove: ["oneHalf", "oneThird", "twoThirds", "oneForth", "threeQuarters"],
                    },
                },
            };
        }
        editorContentChanged() {
            if (this.editorContent !== null && this.editorContent !== undefined) {
                this.$emit("editor-content-changed", this.editorContent);
            }
        }
        get uniqueId() {
            return this._uid;
        }
        onEditorReady(editor) {
            const toolbarContainer = document.querySelector(`#toolbar-container-${this.uniqueId}`);
            if (toolbarContainer) {
                toolbarContainer.appendChild(editor.ui.view.toolbar.element);
            }
            else {
                console.error("Toolbar container not found");
            }
            // Listen for fullscreen changes to remove the class when exiting
            document.addEventListener("fullscreenchange", () => {
                const editorContainer = document.getElementById(`ckEditorWrapper-${this.uniqueId}`);
                if (!document.fullscreenElement) {
                    editorContainer.classList.remove("fullscreen-enable");
                }
                else {
                    editorContainer.classList.add("fullscreen-enable");
                }
            });
        }
        toggleFullScreen() {
            const editorContainer = document.getElementById(`ckEditorWrapper-${this.uniqueId}`);
            if (editorContainer) {
                this.initFullScreen(editorContainer);
            }
        }
        initFullScreen(editorContainer) {
            if (!document.fullscreenElement) {
                if (editorContainer.requestFullscreen) {
                    editorContainer.requestFullscreen();
                }
                else if (editorContainer.mozRequestFullScreen) {
                    editorContainer.mozRequestFullScreen();
                }
                else if (editorContainer.webkitRequestFullscreen) {
                    editorContainer.webkitRequestFullscreen();
                }
            }
            else {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                }
            }
        }
        created() {
            this.editorContent = this.editorData || "";
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], EcTextEditor.prototype, "editorData", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], EcTextEditor.prototype, "allowFullscreen", void 0);
    __decorate([
        Prop({ default: () => ["heading", "|", "bold", "italic", "underline", "link", "|", "bulletedList", "numberedList", "|", "undo", "redo"] }),
        __metadata("design:type", Array)
    ], EcTextEditor.prototype, "toolbarItems", void 0);
    EcTextEditor = __decorate([
        Component({
            name: "EcTextEditor",
            components: {
                ckeditor: CKEditor.component,
            },
        })
    ], EcTextEditor);
    return EcTextEditor;
})();
export default EcTextEditor;
